const features = [
  {
    icon: 'ri-hd-line',
    title: '高清流畅秒播',
    desc: '多线路智能切换，适配不同网络环境。支持1080P高清画质，播放流畅不卡顿，带来影院级观影体验。',
    color: 'primary',
  },
  {
    icon: 'ri-refresh-line',
    title: '同步热播更新',
    desc: '与卫视同步更新最新剧集，第一时间上线完整资源。每日定时更新，不再错过任何精彩内容。',
    color: 'accent',
  },
  {
    icon: 'ri-check-double-line',
    title: '剧集完整无缺',
    desc: '所有剧集提供全集完整版在线观看，无删减无缺失。从第一集到大结局，一追到底不断档。',
    color: 'primary',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '完全免费观看',
    desc: '无需注册登录，无需付费会员，所有影视资源免费在线播放。真正的零门槛追剧体验。',
    color: 'accent',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            四大核心优势，打造极致追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((feat, i) => {
            const isPrimary = feat.color === 'primary';
            return (
              <div
                key={i}
                className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 text-center group hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
              >
                <div
                  className={`w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full transition-colors ${
                    isPrimary
                      ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                      : 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50'
                  }`}
                >
                  <i className={`${feat.icon} text-2xl`}></i>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 whitespace-nowrap">
                  {feat.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {feat.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}